import { Directive, inject, Input, OnDestroy, TemplateRef, ViewContainerRef } from "@angular/core";
import { Subscription } from "rxjs";
import { PermissionService } from "./permission.service";

@Directive({
  selector: "[appHasPermission]",
})
export class HasPermissionDirective implements OnDestroy {
  private _templateRef = inject(TemplateRef<unknown>);
  private _viewContainer = inject(ViewContainerRef);
  private _permissionService = inject(PermissionService);
  private _subscription: Subscription | null = null;
  private _hasView = false;

  @Input() set appHasPermission(code: string) {
    this._subscription?.unsubscribe();
    this._subscription = this._permissionService.has$(code).subscribe((allowed) => {
      if (allowed && !this._hasView) {
        this._viewContainer.createEmbeddedView(this._templateRef);
        this._hasView = true;
      } else if (!allowed && this._hasView) {
        this._viewContainer.clear();
        this._hasView = false;
      }
    });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
